import React, { useRef } from 'react';
import { Popover } from '@fiverr-private/popover';
import { DropdownPopoverProps, DropdownProps, MenuItems } from './types';
import useDropdownState from './useDropdownState';
import { DropdownContext } from './useDropdownContext';

const Dropdown = ({
  children,
  onChange,
  defaultValues,
  values,
  searchWhenClosed = false,
  isOpen,
  onOpenChanged,
  initialOpen,
  disableFlip,
  position = 'bottom-start',
}: DropdownProps & DropdownPopoverProps) => {
  const state = useDropdownState({ onChange, values, defaultValues });
  const anchorRef = useRef<HTMLElement>(null);
  const items = useRef<MenuItems>([]).current;

  return (
    <DropdownContext.Provider value={{ ...state, searchWhenClosed, anchorRef, items }}>
      <Popover
        position={position}
        isOpen={isOpen}
        onOpenChanged={onOpenChanged}
        initialOpen={initialOpen}
        disableFlip={disableFlip}
      >
        {children}
      </Popover>
    </DropdownContext.Provider>
  );
};

export default Dropdown;
